import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _get from 'lodash/get';
import _pick from 'lodash/pick';
import searchMixin from '@/mixin/search';
import { searchUserList } from '@/api/system/user';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import { fetchDemandAllList } from '@/api/demand/demand';
import { fetchTaskAllList } from '@/api/qa/task';
import Pagination from '@/components/Pagination/index.vue';
import AdjustPopover from './adjustPopover.vue';

export default {
  mixins: [searchMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination,
    AdjustPopover: AdjustPopover
  },

  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 15,
        role_type: 2, // 类型
        original_manager: '', // 原负责人
        transform_type: 1, // 转移类型
        search_field: '', // 搜索类型
        keyword: '' // 搜索关键字
      },

      userList: [],

      table: {
        list: [],
        loading: false,
        selection: []
      },
      tableColumnConfig: [],

      pagination: {
        total: 0
      },

      roleTypes: {
        demander: 2,
        designer: 3,
        developer: 4,
        tester: 5
      },
      transformTypes: {
        demand: 1,
        task: 2
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      var _this = this;

      var getSearchFieldList = function getSearchFieldList() {
        var roleType = Number(_this.query.role_type);
        var transformType = Number(_this.query.transform_type);

        // 测试
        if (roleType === _this.roleTypes.tester) {
          return [{
            value: 'id',
            label: '任务ID'
          }];
        }
        // 设计师/开发/提需人 + 转移需求
        if (transformType === _this.transformTypes.demand) {
          return [{
            value: 'id',
            label: '需求id'
          }, {
            value: 'name',
            label: '需求名称'
          }];
        }
        // 设计师/开发/提需人 + 转移任务
        return [{
          value: 'id',
          label: '任务ID'
        }];
      };

      return [{
        prop: 'role_type',
        type: 'select',
        rules: [{
          required: true,
          trigger: 'change',
          message: '选择类型是必填项'
        }],
        params: {
          placeholder: '选择类型',
          options: [{
            value: 2,
            label: '提需人'
          }, {
            value: 3,
            label: '设计师'
          }, {
            value: 4,
            label: '研发'
          }, {
            value: 5,
            label: '测试'
          }],
          handleChange: function handleChange(roleType) {
            roleType = Number(roleType);

            _this.query.original_manager = '';
            _this.query.search_field = '';
            _this.query.keyword = '';

            if (roleType === _this.roleTypes.tester) {
              _this.query.transform_type = _this.transformTypes.task;
            } else {
              _this.query.transform_type = _this.transformTypes.demand;
            }
          }
        }
      }, {
        prop: 'original_manager',
        type: 'select',
        rules: [{
          required: true,
          trigger: 'change',
          message: '原始负责人是必填项'
        }],
        params: {
          placeholder: '原始负责人',
          clearable: true,
          filterable: true,
          options: this.userList,
          handleChange: function handleChange(val) {
            _this.query.search_field = '';
            _this.query.keyword = '';
          }
        }
      }, {
        type: 'select',
        prop: 'transform_type',
        visible: Number(this.query.role_type) !== this.roleTypes.advertiser,
        rules: [{
          required: true,
          trigger: 'change',
          message: '转移类型是必填项'
        }],
        params: {
          placeholder: '转移类型',
          clearable: true,
          options: [{
            value: 1,
            label: '转移需求',
            disabled: Number(this.query.role_type) === this.roleTypes.tester
          }, {
            value: 2,
            label: '转移任务'
          }],
          handleChange: function handleChange(val) {
            _this.query.search_field = '';
            _this.query.keyword = '';
          }
        }
      }, {
        type: 'select',
        prop: 'search_field',
        params: {
          clearable: true,
          placeholder: '查找类型',
          options: getSearchFieldList(),
          handleChange: function handleChange(val) {
            _this.query.keyword = '';
          }
        }
      }, {
        type: 'input',
        prop: 'keyword',
        params: {
          clearable: true,
          placeholder: '搜索关键字'
        }
      }];
    },
    searchButton: function searchButton() {
      return {
        disabled: !this.query.original_manager
      };
    }
  },

  watch: {
    $route: function $route() {
      this.tableColumnConfig = this.getTableColumnConfig();
      this.fetchUserList();
      this.dispatch();
    }
  },

  mounted: function mounted() {
    this.tableColumnConfig = this.getTableColumnConfig();
    this.fetchUserList();
    this.dispatch();
  },


  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.table.selection = val.map(function (item) {
        return item.id;
      });
    },
    handleAdjustSuccess: function handleAdjustSuccess() {
      this.dispatch();
    },
    getTableColumnConfig: function getTableColumnConfig() {
      var roleType = Number(this.query.role_type);

      if (roleType === this.roleTypes.tester) {
        return [{
          type: 'selection'
        }, {
          label: '任务ID',
          prop: 'id'
        }];
      }

      if (this.isOtherRoles(roleType)) {
        var transformType = Number(this.query.transform_type);

        if (transformType === this.transformTypes.task) {
          return [{
            type: 'selection'
          }, {
            label: '任务ID',
            prop: 'id'
          }];
        }

        return [{
          type: 'selection'
        }, {
          label: '需求ID',
          prop: 'id'
        }, {
          label: '需求名称',
          prop: 'name'
        }];
      }

      return [];
    },
    dispatch: function dispatch() {
      var _this2 = this;

      var roles = {
        // 提需人/设计师/开发，找不到好的单词表示，就用 otherRoles 吧
        otherRoles: function otherRoles(roleType) {
          var transformType = Number(_this2.query.transform_type);
          var params = _pick(_this2.query, ['page', 'page_size', 'search_field', 'keyword']);

          if (roleType === _this2.roleTypes.demander) {
            params.demander_ids = _this2.query.original_manager;
          }
          if (roleType === _this2.roleTypes.designer) {
            params.designer_ids = _this2.query.original_manager;
          }
          if (roleType === _this2.roleTypes.developer) {
            params.developer_ids = _this2.query.original_manager;
          }

          // 转移需求
          if (transformType === _this2.transformTypes.demand) {
            _this2.fetchDemandList(_extends({}, params, { exclude_statuses: 'delivered' }));
          } else {
            // 转移任务
            _this2.fetchTaskList(_extends({}, params, { exclude_statuses: '9' }));
          }
        },

        tester: function tester() {
          var params = _extends({}, _pick(_this2.query, ['page', 'page_size', 'search_field', 'keyword']), {
            tester_ids: _this2.query.original_manager,
            exclude_statuses: '9'
          });
          _this2.fetchTaskList(params);
        }
      };

      var roleType = Number(this.query.role_type);

      if (this.isOtherRoles(roleType)) {
        roles.otherRoles(roleType);
      }

      if (roleType === this.roleTypes.tester) {
        roles.tester();
      }
    },
    isOtherRoles: function isOtherRoles(roleType) {
      return [this.roleTypes.demander, this.roleTypes.designer, this.roleTypes.developer].indexOf(roleType) > -1;
    },
    fetchTaskList: function fetchTaskList(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.table.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return fetchTaskAllList(params);

              case 4:
                res = _context.sent;
                list = _get(res, 'data.data.list') || [];

                _this3.table.list = list;
                _this3.table.loading = false;
                _this3.pagination.total = _get(res, 'data.data.total') || 0;
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                _this3.table.loading = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 11]]);
      }))();
    },
    fetchDemandList: function fetchDemandList(params) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, list;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.table.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return fetchDemandAllList(params);

              case 4:
                res = _context2.sent;
                list = _get(res, 'data.data.list') || [];

                _this4.table.list = list;
                _this4.table.loading = false;
                _this4.pagination.total = _get(res, 'data.data.total') || 0;
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](1);

                _this4.table.loading = false;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 11]]);
      }))();
    },
    fetchUserList: function fetchUserList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res, list;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return searchUserList({
                  page: 1,
                  page_size: 1000
                });

              case 3:
                res = _context3.sent;
                list = _get(res, 'data.data.list') || [];

                _this5.userList = list.map(function (item) {
                  return {
                    value: item.id,
                    label: item.real_name
                  };
                });
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                _this5.userList = [];

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 8]]);
      }))();
    }
  }
};